import { GenerateLeaseContractResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const generateContract = async (orderId: string): Promise<GenerateLeaseContractResponse> => {
  try {
    const { data } = await applicationFormService.generateContract({ orderId });

    return data?.generateLeaseContract as GenerateLeaseContractResponse;
  } catch (err: any) {
    const error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
        break;
    }
    throw error;
  }
};

export default generateContract;
